var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-carousel',_vm._b({},'el-carousel',_vm.$attrs,false),_vm._l((_vm.images),function(img){return _c('el-carousel-item',{key:img.id},[_c('el-image',{attrs:{"src":img.url,"fit":"cover"}},[_c('div',{staticClass:"image-slot",attrs:{"slot":"error"},slot:"error"},[_vm._v("暂无图片")])])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }